// src/components/free-trial/GoodToHaveYou.tsx
import { OnboardingStepProps } from '../../registration';
import {
  ContentSection,
  ContinueButton,
  ButtonsContainer,
  SkipButton,
} from '../secure-your-account/secure-your-account.styled';
import styled from '@emotion/styled';
import { VSpace } from '../../../chat/settings/account/account-settings';

export const Heading = styled.div`
  font-family: Custora;
  font-weight: 300;
  font-style: Light;
  font-size: 32px;
  leading-trim: NONE;
  line-height: 36px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #e9ecf5;
`;

export const SubHeading = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #b7bdcb;
`;
export const GoodToHaveYou: React.FC<OnboardingStepProps> = ({ goNext, goPrev }) => {
  return (
    <ContentSection data-testid="ob-trial">
      <div></div>
      <div>
        <Heading data-testid="ob-trial-heading">Welcome.</Heading>
        <VSpace $h={43} />
        <SubHeading data-testid="ob-trial-subheading">Good to have you. </SubHeading>
        <VSpace $h={16} />
        <SubHeading data-testid="ob-trial-subheading">
          I built this for people like you.<br></br> Builders who cut through the noise<br></br> to
          get signal.
        </SubHeading>{' '}
        <VSpace $h={16} />
        <SubHeading data-testid="ob-trial-subheading">I’ll see you inside.</SubHeading>
      </div>
      <ButtonsContainer data-testid="ob-trial-actions">
        <ContinueButton data-testid="ob-trial-continue" disabled={false} onClick={goNext}>
          Enter{' '}
        </ContinueButton>
        <SkipButton data-testid="ob-trial-back" onClick={goPrev}>
          Back
        </SkipButton>
      </ButtonsContainer>
    </ContentSection>
  );
};

(GoodToHaveYou as any).background = 'linear-gradient(180deg, #222327 0%, #1A1A1C 100%);';
(GoodToHaveYou as any).progress = 'Setup';
(GoodToHaveYou as any).smallLogo = true;
(GoodToHaveYou as any).fill = false;
